export default "__VITE_ASSET__6c73656b__"